<template>
  <div class="load-bag" v-if="showLoader">
  <div class="lds-ripple" ><div></div><div></div></div>
  </div>
    <Dashboard/>
      <!-- Main Content -->
      <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Verified Users</h1>
            <div class="section-header-breadcrumb">
              <div class="breadcrumb-item active"><router-link to="/dashboard">Home</router-link></div>
              <div class="breadcrumb-item">Verified Users</div>
            </div>
          </div>
          <div class="section-body">
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <!-- <div class="card-header d-Fle">
                    <h4>Export Table</h4>
                  </div> -->
                  <div class="card-body">
                    <div class="table-responsive newPc">
                      <table
                        class="table table-bordered table-hover"
                        id="tableExport"
                        style="width: 100%"
                      >
                        <thead>
                          <tr>
                            <th>S No.</th>
                            <th>Name</th>
                            <th>Email ID</th>
                            <th>Contact No.</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in result" :key="item._id">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.name }}</td>
                            <td class="EmailID">{{ item.email }}</td>
                            <td v-if="item.mobile">{{ item.mobile }}</td>
                            <td v-else>--</td>
                            <td>
                              <button class="btn  featured" @click="Active(item._id, item.is_active)"  v-if="(item.is_active == true)" style="color:green">Active</button>
                              <button class="btn  featured" @click="Active(item._id, item.is_active)"  v-else style="color:red">Inactive</button>
                            </td>
                            <td class="action">
                              <!-- <a data-toggle="modal"  
                              data-target=".payment-modal" @click="ViewUser(item._id)"
                              ><i class="far fa-credit-card"></i
                                ></a> -->
                                <!-- <a data-toggle="modal"  
                              data-target=".edit-modal" @click="ViewUser(item._id)"
                              ><i class="far fa-edit"></i
                                ></a> -->
                              <a data-toggle="modal"  @click="ViewUser(item._id)"
                              data-target=".view-user-modal"
                              ><i class="far fa-eye"></i
                                ></a>
                              <a  @click="DeleteUser(item._id)"><i class="far fa-trash-alt"></i></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>


      <!-- View User Modal start -->
      <div
        class="modal fade view-user-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">User Details</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="custom-table">
                  <table class="table-bordered w-100">
        <tbody>
            <tr>
            <th class="p-3"><i class="fa fa-user" style="color:#16bc91e3"></i> &nbsp;Name</th>
            <td class="p-3">{{ this.viewname }}</td>
            </tr>
            <tr>
            <th class="p-3"><i class="fa fa-envelope" style="color:#16bc91e3"></i> &nbsp;Email</th>
            <td class="p-3">{{ this.viewemail }}</td>
            </tr>
            <tr>
            <th class="p-3"> <i class="fa fa-mobile" style="color:#16bc91e3"></i> &nbsp;&nbsp;Contact Number</th>
            <td class="p-3" v-if="this.viewphone_number">{{ this.viewphone_number }}</td>
            <td class="p-3" v-else>--</td>
            </tr>
            <tr>
            <th class="p-3"><i class="fa fa-check" style="color:#16bc91e3"></i> &nbsp;Status</th>
            <td class="p-3" v-if="this.is_active==1"> Active</td>
            <td class="p-3" v-else> Inactive</td>
            </tr>
            <tr>
            <th class="p-3" colspan="2"><i class="fa fa-file-invoice" style="color:#16bc91e3"></i> &nbsp;Document</th>
           
          
            </tr>
            <tr>
           
            <td class="p-3" colspan="2"  v-if="this.viewimage_url.length!==0">
              <div class="row">
                
              <div class="col-md-4" v-for="item in viewimage_url" :key="item">
                <a target="_blank" :href='item'> <img :src="item" class="Image w-100"/></a>
              </div>
            </div>
            </td>
            <td class="p-3" v-else>No document provied</td>
            </tr>
        </tbody>
    </table>
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- View User Modal end -->

 <!-- View payment Modal start -->
 <div
        class="modal fade payment-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">User Payment Details</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="custom-table">
                  <table class="table-bordered w-100">
        <tbody>
            <tr>
            <th class="p-3"><i class="fa fa-calendar" style="color:#16bc91e3"></i> &nbsp;Date of Transaction</th>
            <td class="p-3">{{  }}</td>
            </tr>
            <tr>
            <th class="p-3"><i class="fa fa-clock" style="color:#16bc91e3"></i> &nbsp;Time of Transaction</th>
            <td class="p-3">{{  }}</td>
            </tr>
            <tr>
            <th class="p-3"><i class="fa fa-pen" style="color:#16bc91e3"></i> &nbsp;Transaction ID</th>
            <td class="p-3">{{ }}jnrgelkregnlk243342knr3k24n32k4 </td>
            </tr>
            <tr>
            <th class="p-3"><i class="fa fa-sack-dollar" style="color:#16bc91e3"></i> &nbsp;Total Fees</th>
            <td class="p-3">{{  }}</td>
            </tr>
            <tr>
            <th class="p-3"> <i class="fa fa-hand-holding-dollar" style="color:#16bc91e3"></i> &nbsp;&nbsp;Commission for Admin</th>
            <td class="p-3" >{{ 4 }}</td>
            <!-- <td class="p-3" v-else>--</td> -->
            </tr>
        </tbody>
    </table>
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- View payment Modal end -->

      <!-- Edit user Modal start -->
      <div
        class="modal fade edit-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="myLargeModalLabel">
                Edit Details
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="viewname"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>Contact Number</label>
                    <input
                      type="text"
                      minlength="6" maxlength="15" 
                     oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                      class="form-control"
                      v-model="viewphone_number"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label>Email ID</label>
                    <input
                      type="email"
                      class="form-control"
                      readonly
                      v-model="viewemail"/>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <input
                    type="button"
                    value="Update Details"
                    @click="Updateuser(viewid)"
                    class="modal-btn"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Edit user Modal end -->
</template>

<script>
import { defineComponent } from 'vue'
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'
import Dashboard from '@/components/Dashboard.vue'
import axios from "../services/customAxios";
import { base_url } from "../config";
export default defineComponent({
  name: 'UserManagement',
  components: {
    Dashboard
  },
  setup () {
    const toast = () => {
        createToast()
    }
    return { toast }
  },
  data(){
    return{
      result:[],       
      base_url: base_url,
      name: "",
      phone_number: "",
      is_active:"",
      viewname:"",
      viewemail:"",
      viewimage_url:"",
      viewphone_number:"",
      viewid:"",
      showLoader: true,
      res:"",
      resultpay:[]
    }
  },
  methods:{
    async LoadUser() {
      try{
      let response = await axios.get(`${base_url}/get_all_verified_user`); 
      console.log("==========>>>>>",response.data.result);
      this.result = response.data.result;
    }
    catch (error) {
      if (error) {
        this.showLoader= false;
          this.result = [];
        }
      }
    },
    async DeleteUser(_id) {
      if (confirm("Are you sure you want to delete this User?")) {
        let response = await axios.delete(`${base_url}/delete_user/` + _id);
        console.log("efhiueqhfwqdjiw",response.data);
        createToast({title: "Success", description: response.data.message},{type: "success"})
        this.LoadUser();
      }
    },
    async ViewUser(_id) {
      let response = await axios.get(`${base_url}/get_user/`+ _id); 
      console.log("=====View User=====>>>>>",response.data.result);
      this.viewname = response.data.result.name;
      this.viewemail = response.data.result.email;
      this.viewphone_number = response.data.result.mobile;
      this.viewid= response.data.result._id,
      this.is_active= response.data.result.is_active,
      this.viewimage_url= response.data.result.image_url
    },
    async Updateuser(viewid) {
      try{
      const response = await axios.put(
        `${base_url}/update_user/` + viewid,{
          name: this.viewname,
          mobile: this.viewphone_number,
        }
      );
      createToast({title: "Success", description: response.data.message},{type: "success"})
      if(response.data.success == true){
          window.location.reload();
        }
      }
      catch(error){
        createToast({title: "Error", description: error?.response?.data?.message},{type: "danger"})
      }
    },
    async Active(_id , is_active) {
      if (!is_active) {
       let response = await axios.put(`${base_url}/active_deactive_user/`+_id, {
          is_active: true,
      });
      createToast({title: "Success", description: response.data.message},{type: "success"})
      } else {
        let response = await axios.put(`${base_url}/active_deactive_user/`+_id, {
          is_active: false,
          });
          createToast({title: "Success", description: response.data.message},{type: "success"})
      }
      this.LoadUser();
    },
    // async ViewPayment(id) {
    //   let response = await axios.get(`${base_url}/payments-list/`+ id); 
    //   console.log("=====View dataaaaadfdoijfjeof eipfw jojf=====>>>>>",response.data.data);
    //   this.res =response.data.success;
    //   this.resultpay =response.data.data.reverse();
    // },
  },
  async mounted(){
    this.LoadUser();
    this.ViewUser();
    let recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'assets/pages/datatables.js');
    setTimeout(() => {
      document.body.appendChild(recaptchaScript)  
      this.showLoader= false
    }, 3500);
  }
});
</script>

<style>
/* .modal.show .modal-dialog{transform: translateY(20%);} */
.Image{
  height: 330px;
  object-fit: contain;
  box-shadow: 2px 2px 6px lightgrey;
}
</style>